import { useMemo } from 'react';
import type { DropDownMenuOption } from '@replai-platform/ui-components';
import * as SDK from '@replai-platform/sdk';

const useBreakdownFilter = ({
  breakdown,
  onChange,
}: {
  breakdown: SDK.Breakdown;
  onChange: (value: SDK.Breakdown) => void;
}): { breakdownFilterOptions: DropDownMenuOption[] } => {
  // Create filter options
  const breakdownFilterOptions = useMemo(
    () => [
      {
        label: 'Network',
        selected: breakdown === 'network',
        onClick: () => onChange('network'),
      },
      {
        label: 'Country',
        selected: breakdown === 'country',
        onClick: () => onChange('country'),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [breakdown]
  );

  return { breakdownFilterOptions };
};

export default useBreakdownFilter;
